import React, { useEffect, useRef, useState } from "react";
import { ReactSVG } from "react-svg";
import { setSVGColor } from "../SVGHelper";
import { loginSession } from "../LoginSession";
import logoutIcon from "../icon/dashboard/Log/Out.svg";
import moreIcon from "../icon/dashboard/Menu/Menu 2.svg";
import pmgLogo from "../icon/pmg/PMG_Intelligence_Logo_FullColour_RGB.svg";
import userIcon from "../icon/UserCircle.svg";
import Button from "./Button";
import "../style/shadows.scss";
import { useLoginSession } from "../LoginSession";
import sharedConfig from "../config";
import { getPrimaryLandingPage } from "../utils";

const MainHeader = ({ links = [], style = {}, onToggleDrawer = () => {}, drawerDisabled = false }) => {
    const { userInfo } = useLoginSession(false);

    const [landingPage, _setLandingPage] = useState(getPrimaryLandingPage(userInfo));
    useEffect(() => {
        _setLandingPage(getPrimaryLandingPage(userInfo));
    }, [userInfo]);

    const name = userInfo?.fullName || userInfo?.email || "";

    const headerRef = useRef(null);

    const HeaderLink = (props) => (
        <Button
            className="lnk-color"
            indicateActiveNav
            {...props}
            style={{
                margin: "-2px 1px", // if we wrap we dont want to take up more space than we need
            }}
        />
    );

    return (
        <>
            <header
                className="underline-sm-grayscale-200"
                style={{ ...style, backgroundColor: "var(--colors-base-00)" }}
                ref={headerRef}
            >
                <div style={{ padding: "16px 22px" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "11px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "left",
                                width: "100%", // this and the last div are set to 100% to ensure the middle div is centered irrespective of the content width of either
                                gap: "48px", //something cool: gap: 'min(max(20px, 3vw), 52px)',
                            }}
                        >
                            {!drawerDisabled && (
                                <button onClick={onToggleDrawer} className="mx-2">
                                    <ReactSVG
                                        src={moreIcon}
                                        alt="more"
                                        beforeInjection={(svg) => {
                                            setSVGColor("var(--colors-main-2)", true)(svg);
                                        }}
                                    />
                                </button>
                            )}
                            <Button
                                to={landingPage}
                                className="" // ditch the default styling
                                style={{ marginRight: "8px" }}
                            >
                                <ReactSVG
                                    src={pmgLogo}
                                    alt="PMG Intelligence"
                                    beforeInjection={(svg) => {
                                        svg.setAttribute("width", "90px");
                                        svg.setAttribute("height", "44px");
                                    }}
                                />
                            </Button>
                        </div>

                        {/* App Supplied Links */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "min(max(1px, calc(2.15vw - 32px)), 40px)", // scales but with upper/lower bounds
                                flexWrap: "wrap",
                                width: "200%", // make this one hoard space so we don't wrap (others are 100%)
                            }}
                        >
                            {links.map((link) => (
                                <HeaderLink to={link.path} onClick={link.onClick}>
                                    {link.label}
                                </HeaderLink>
                            ))}
                        </div>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "right",
                                gap: "8px",
                                width: "100%", // this and the first div are set to 100% to ensure the middle div is centered irrespective of the content width of either
                            }}
                        >
                            {userInfo && (
                                <>
                                    <HeaderLink
                                        svg={userIcon}
                                        to={`${sharedConfig.centralFrontendURL}account-management`}
                                        indicateActiveNav={false} // Don't indicate here as it's not a primary navigation link
                                    >
                                        {name}
                                    </HeaderLink>
                                    <HeaderLink onClick={() => loginSession.logout()}>
                                        <ReactSVG
                                            src={logoutIcon}
                                            alt="Logout"
                                            beforeInjection={(svg) => {
                                                setSVGColor("var(--colors-main-2)", true)(svg);
                                            }}
                                        />
                                    </HeaderLink>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default MainHeader;
